import { render, staticRenderFns } from "./RenterForm.vue?vue&type=template&id=35f54051"
import script from "./RenterForm.vue?vue&type=script&lang=js"
export * from "./RenterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports